import React, { useState } from 'react';
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  IconButton,
  useToast,
  Box,
  Tooltip,
  Text
} from '@chakra-ui/react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

function EnvTable({ envData, readOnly }) {
  const [visibleRows, setVisibleRows] = useState({});
  const toast = useToast();

  const toggleVisibility = (index) => {
    setVisibleRows(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  return (
    <Box overflowX="auto" borderRadius="md" boxShadow="sm" width="100%">
      <Box maxW="100%" overflowX="auto">
      <Table 
        variant="simple" 
        size="sm" 
        borderWidth="1px" 
        borderColor="gray.200" 
        _dark={{ borderColor: "gray.600" }}
      >
        <Thead>
          <Tr>
            <Th borderWidth="1px" borderColor="gray.200" _dark={{ borderColor: "gray.600" }} width="300px">Key</Th>
            <Th borderWidth="1px" borderColor="gray.200" _dark={{ borderColor: "gray.600" }} maxW="400px">Value</Th>
            <Th width="80px" borderWidth="1px" borderColor="gray.200" _dark={{ borderColor: "gray.600" }}>Actions</Th>
          </Tr>
        </Thead>
        <Tbody>
          {envData && envData.length > 0 ? (
            envData.map((item, index) => (
              <Tr key={index}>
                <Td 
                  fontWeight="bold" 
                  borderWidth="1px" 
                  borderColor="gray.200" 
                  _dark={{ borderColor: "gray.600" }}
                  width="300px"
                  maxW="400px"
                  overflow="hidden"
                  textOverflow="ellipsis"
                >
                  {item.key}
                </Td>
                <Td 
                  borderWidth="1px" 
                  borderColor="gray.200" 
                  _dark={{ borderColor: "gray.600" }}
                  maxW="400px"
                  overflow="hidden"
                  textOverflow="ellipsis"
                >
                  <Box maxW="400px" overflow="auto" whiteSpace="pre-wrap" p={0}>
                    {visibleRows[index] ? (
                      <Text color="inherit" fontSize="sm">{item.value}</Text>
                    ) : (
                      <Text as="span" letterSpacing="2px" filter="blur(4px)" color="inherit" fontSize="sm">
                        {item.value.replace(/./g, '•')}
                      </Text>
                    )}
                  </Box>
                </Td>
                <Td borderWidth="1px" borderColor="gray.200" _dark={{ borderColor: "gray.600" }} width="80px">
                  <Tooltip label={visibleRows[index] ? "Hide value" : "Show value"}>
                    <IconButton
                      aria-label={visibleRows[index] ? "Hide value" : "Show value"}
                      icon={visibleRows[index] ? <FaEyeSlash /> : <FaEye />}
                      size="sm"
                      onClick={() => toggleVisibility(index)}
                    />
                  </Tooltip>
                </Td>
              </Tr>
            ))
          ) : (
            <Tr>
              <Td colSpan={3} textAlign="center" borderWidth="1px" borderColor="gray.200" _dark={{ borderColor: "gray.600" }}>No environment variables found.</Td>
            </Tr>
          )}
        </Tbody>
      </Table>
      </Box>
    </Box>
  );
}

export default EnvTable;
